// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WLaC81dSHwHnb1lFXvIE{padding:0 24px 24px;position:relative}.nw_sOV9Dovs0TMsYKiB7{flex-direction:column;gap:4px;display:flex}.nw_sOV9Dovs0TMsYKiB7:not(:empty){padding-bottom:20px}._hOQor18vtgvMfiCjqWx{padding:0}._hOQor18vtgvMfiCjqWx input{height:18px;font-size:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `WLaC81dSHwHnb1lFXvIE`,
	"alertContainer": `nw_sOV9Dovs0TMsYKiB7`,
	"textField": `_hOQor18vtgvMfiCjqWx`
};
export default ___CSS_LOADER_EXPORT___;
